module.exports = __webpack_public_path__ + "img/Haefele_menu4.d5af9958.png";